import {FC, ReactNode} from 'react';

import {twx} from '@/utils/tailwindUtils';

export interface PageHeaderProps {
    className?: string;
    headline?: ReactNode;
    title?: ReactNode;
    subtitle?: ReactNode;
    startIcon?: ReactNode;
    endIcon?: ReactNode;
}

const PageHeader: FC<PageHeaderProps> = ({className, headline, title, subtitle, startIcon, endIcon}) => {
    return (
        <header className={twx('w-full', className)}>
            {(startIcon || endIcon) && (
                <div className='flex items-center justify-between'>
                    {startIcon && <div className='flex items-center'>{startIcon}</div>}
                    {endIcon && <div className='flex items-center'>{endIcon}</div>}
                </div>
            )}
            <div className='mt-4 flex flex-col gap-2 text-start ml:mt-6 ml:text-center'>
                {headline && (
                    <p className='text-14 font-bold leading-[20px] tracking-02 text-primary-dark-85'>{headline}</p>
                )}
                {title && (
                    <h1 className='mb-0 text-32 font-bold leading-[40px] text-primary-dark ml:text-28'>{title}</h1>
                )}
                {subtitle && <p className='text-16 leading-16 tracking-0 text-primary-dark'>{subtitle}</p>}
            </div>
        </header>
    );
};

export default PageHeader;
